(ns hai.learn-more
  "\"Learn more\": a way from an app's surfaces to the humbleai.com page on
   that app ([[url.how-it-works]]), opened in a new tab as a real link. App
   card headers — on Home and in the extension sidebar — wear it as the ⋮
   `menu`; the app pages as a `popover-row` in their ⋮ settings popover."
  (:require
   [hai.entity.kebab :as kebab]
   [hai.ui.components :as c]
   [hai.ui.icons :as icons]
   [lambdaisland.ornament :as o]))

(def ^:private help-icon(icons/mui-icon :outlined :help_outline))

(defn menu
  "The ⋮ menu over the page at `url`; `label` names the card in the trigger's
   accessible name."
  [{:keys [url label]}]
  [kebab/menu
   {:actions    [["Learn more" url help-icon]]
    :aria-label (str label " actions")}])

;; Laid out like the popover's checkbox rows, the icon standing in the
;; checkbox's place.
(o/defstyled popover-row :a
  {:display "flex" :align-items "center" :gap "0.5rem"
   :color "inherit" :text-decoration "none"
   :cursor "pointer"}
  [:svg {:width "18px" :height "18px" :fill "currentColor"}]
  [:&:hover [:.learn-more-label {:text-decoration "underline"
                                 :text-underline-offset "3px"}]]
  ([{:keys [url]}]
   [:<> {:href url :target "_blank" :rel "noopener noreferrer"}
    [help-icon]
    [c/Text {:class "learn-more-label"} "Learn more"]]))
